import { Chip, Tooltip } from '@mui/material';
import { DateTime } from 'luxon';
import { type FC } from 'react';

import { type NvrSyncStatus } from '../../api/nvrs.api.js';

const SYNC_CHIP: Record<NvrSyncStatus['status'], { label: string; color: 'default' | 'info' | 'warning' | 'success' | 'error' }> = {
  idle: { label: '—', color: 'default' },
  queued: { label: 'Queued', color: 'info' },
  running: { label: 'Syncing…', color: 'warning' },
  success: { label: 'Synced', color: 'success' },
  failed: { label: 'Failed', color: 'error' },
};

const SyncChip: FC<{ status?: NvrSyncStatus }> = ({ status }) => {
  const s = status?.status ?? 'idle';
  const { label, color } = SYNC_CHIP[s];
  const when = status?.finishedAt ? DateTime.fromMillis(status.finishedAt).toRelative() : null;
  const tooltip = s === 'failed' && status?.error
    ? status.error
    : when ? `${label} ${when}` : label;
  return (
    <Tooltip arrow title={tooltip}>
      <Chip size="small" label={label} color={color} variant={s === 'idle' ? 'outlined' : 'filled'} />
    </Tooltip>
  );
};

export default SyncChip;
